var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
(function () {
    angular.module('QMC.Termin', ['QMC.Fachleistung']).config(routes);
    ;
    routes.$inject = ['$locationProvider', '$stateProvider', '$urlRouterProvider', 'qmcBase'];
    function routes($locationProvider, $stateProvider, $urlRouterProvider, qmcBase) {
        $locationProvider.html5Mode({
            enabled: false,
            requireBase: false
        });
        $stateProvider
            .state('appointment', {
            url: '/appointment?:startDay?view',
            templateUrl: qmcBase + '/termin',
            controller: 'TerminListController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Appointment List');
                    }]
            },
            params: {
                startDay: {
                    dynamic: true
                },
                view: {
                    dynamic: true
                }
            }
        })
            .state('appointment.detail', {
            url: '/appointment/:id/:isRecurring/:participantId/:dateFrom/:start/:end/:wholeSerie/:permFlag',
            templateUrl: qmcBase + '/termin/detail',
            controller: 'TerminDetailController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Appointment Detail');
                    }]
            }
        })
            .state('appointment.detailshort', {
            url: '/appointment/:id',
            templateUrl: qmcBase + '/termin/detail',
            controller: 'TerminDetailController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Appointment Detail SHORT');
                    }]
            }
        });
    }
})();
var QMC;
(function (QMC) {
    var Termin;
    (function (Termin) {
        var HttpProvider = /** @class */ (function () {
            function HttpProvider() {
            }
            HttpProvider.configureHttpProvider = function ($httpProvider) {
                // initialize get if not there
                if (!$httpProvider.defaults.headers.get) {
                    $httpProvider.defaults.headers.get = {};
                }
                // disable IE ajax request caching
                $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
                // extra
                $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
                $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
            };
            return HttpProvider;
        }());
        Termin.HttpProvider = HttpProvider;
    })(Termin = QMC.Termin || (QMC.Termin = {}));
})(QMC || (QMC = {}));
(function () {
    angular.module('QMC.Termin')
        .config(['$httpProvider', QMC.Termin.HttpProvider.configureHttpProvider]);
})();
var QMC;
(function (QMC) {
    var Termin;
    (function (Termin) {
        var TerminService = /** @class */ (function (_super) {
            __extends(TerminService, _super);
            function TerminService($http, $q) {
                var _this = _super.call(this, $http, $q) || this;
                _this.$http = $http;
                _this.$q = $q;
                _this.modulePath = '/Appointment';
                return _this;
            }
            TerminService.prototype.getCalendarList = function () {
                return _super.prototype.get.call(this, this.modulePath + '/Calendar', {}, function (data) {
                    return data;
                });
            };
            TerminService.prototype.getAppointmentTypes = function () {
                return _super.prototype.get.call(this, this.modulePath + '/Type', {}, function (data) {
                    return data;
                });
            };
            TerminService.prototype.getAppointmentList = function (personObjectId, dateFrom, dateTo, appointmentTypes, getOrganisation) {
                var _this = this;
                if (getOrganisation === void 0) { getOrganisation = false; }
                return _super.prototype.getItem.call(this, this.modulePath, { personObjectId: personObjectId, dateFrom: dateFrom, dateTo: dateTo, appointmentTypes: appointmentTypes, getOrganisation: getOrganisation }, function (data) {
                    _this.displayNotifications(data.errors, "Hinweis", "warning", "qm-icon-information");
                    return data.items;
                });
            };
            //getAppointment(id: Guid, isRecurring: boolean, participantId: Guid, dateFrom: any): any {
            //    return super.get(this.modulePath + '/' + id + '/' + isRecurring + '/' + participantId + '/' + moment(dateFrom).format('YYYY-MM-DD'), {}, (data: IAppointment[]) => {
            //        return data;
            //    });
            //}
            TerminService.prototype.getAppointment = function (id, participantId, dateFrom, wholeSerie, permFlag) {
                return _super.prototype.get.call(this, this.modulePath + '/' + id, { participantId: participantId, dateFrom: moment(dateFrom).format('YYYY-MM-DD'), wholeSerie: wholeSerie, permFlag: permFlag }, function (data) {
                    return data;
                });
            };
            TerminService.prototype.getAppointmentWv = function () {
                return _super.prototype.getItem.call(this, this.modulePath + '/WvModel', {}, function (data) {
                    return data;
                });
            };
            TerminService.prototype.postAppointment = function (data) {
                return _super.prototype.post.call(this, this.modulePath, data).then(function (d) {
                    return d;
                });
            };
            TerminService.prototype.putAppointment = function (id, isRecurring, participantId, dateFrom, wholeSeries, data, changeRecurrenceDay) {
                if (changeRecurrenceDay === void 0) { changeRecurrenceDay = false; }
                return _super.prototype.put.call(this, this.modulePath + '/' + id + '/' + isRecurring + '/' + participantId + '/' + moment(dateFrom).format('YYYY-MM-DD') + '/' + wholeSeries + ("?changeRecurrenceDay=" + changeRecurrenceDay), data).then(function (d) {
                    return d;
                });
            };
            TerminService.prototype.deleteAppointment = function (id, isRecurring, participantId, dateFrom, wholeSeries, allParticipants) {
                return _super.prototype.delete.call(this, this.modulePath + '/' + id + '/' + isRecurring + '/' + participantId + '/' + moment(dateFrom).format('YYYY-MM-DD') + '/' + wholeSeries + '/' + allParticipants).then(function (e) {
                    return e;
                });
            };
            TerminService.prototype.validateAppointment = function (request) {
                return _super.prototype.post.call(this, this.modulePath + '/validation', request).then(function (data) {
                    return data;
                });
            };
            TerminService.prototype.getHolidays = function (year) {
                return _super.prototype.get.call(this, this.modulePath + '/holiday', { year: year }, function (data) {
                    return data;
                });
            };
            TerminService.prototype.getHolidaysSpecific = function (year, getHolidayDays, getVacationDays) {
                return _super.prototype.get.call(this, this.modulePath + '/holiday', { year: year, getHolidayDays: getHolidayDays, getVacationDays: getVacationDays }, function (data) {
                    return data;
                });
            };
            TerminService.prototype.getShareablePersonList = function () {
                return _super.prototype.get.call(this, this.modulePath + '/Calendar/ShareablePerson', {}, function (data) {
                    return data;
                });
            };
            TerminService.prototype.getAccessibleCalenderList = function (objectType) {
                return _super.prototype.get.call(this, this.modulePath + '/Calendar/Accessible', { objectType: objectType }, function (data) {
                    return data;
                });
            };
            TerminService.prototype.getCalendarTypeList = function () {
                return _super.prototype.get.call(this, this.modulePath + '/Calendar/Type', {}, function (data) {
                    return data;
                });
            };
            TerminService.prototype.putAccessible = function (list) {
                return _super.prototype.put.call(this, this.modulePath + '/Calendar/Accessible/SetAllocationStates', list).then(function (data) {
                    return data;
                });
            };
            TerminService.prototype.putShareOwnCalendar = function (list) {
                return _super.prototype.put.call(this, this.modulePath + '/Calendar/ShareOwnCalendarWithPersons', list).then(function (data) {
                    return data;
                });
            };
            TerminService = __decorate([
                QMC.Service('QMC.Termin', 'TerminService'),
                QMC.Inject('$http', '$q')
            ], TerminService);
            return TerminService;
        }(QMC.Common.BaseService));
        Termin.TerminService = TerminService;
    })(Termin = QMC.Termin || (QMC.Termin = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Termin;
    (function (Termin) {
        var UserInterface = /** @class */ (function (_super) {
            __extends(UserInterface, _super);
            function UserInterface() {
                var _this = _super.call(this) || this;
                _this.appointmentForm = {
                    form: [
                        {
                            label: "Betreff",
                            placeholder: "",
                            type: "String",
                            model: "title",
                            required: true,
                            lngTag: "20018006",
                            validate: {
                                message: "Bitte den Betreff angeben.",
                                messageTag: "20018024"
                            },
                            style: {
                                class: "col-xs-12",
                                icon: "fa fa-font"
                            }
                        },
                        {
                            label: "Teilnehmer",
                            type: "Select2",
                            model: "participantIds",
                            id: "selectedClientIds",
                            dataSource: "getParticipants",
                            lngTag: "20018007",
                            multiple: true,
                            required: true,
                            validate: {
                                message: "Bitte einen Teilnehmer auswählen."
                            },
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            type: "hr"
                        },
                        {
                            type: "DateRange",
                            requiredTo: true,
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            label: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis"
                            },
                            lngTag: {
                                dateFrom: "20000047",
                                dateTo: "20000054"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayTime: true,
                                displayDateTo: true,
                                disableDate: false,
                                disableTime: "isAllDay",
                                dateToRequired: true
                            },
                            events: {
                                hideExpression: "(qmForm.recuringType > 0 && !qmForm.disableRecurring)"
                            }
                        },
                        {
                            type: "DateRange",
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            label: {
                                dateFrom: "Wiederholen ab"
                            },
                            lngTag: {
                                dateFrom: "20018540"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayTime: true,
                                disableTime: false,
                                displayDateTo: false,
                                dateToRequired: false,
                                disableDate: false
                            },
                            events: {
                                hideExpression: "((qmForm.recuringType == 0 || qmForm.recuringType == null) || (qmForm.disableRecurring))"
                            }
                        },
                        {
                            label: "Ort",
                            placeholder: "Ort angeben",
                            placeholderTag: "20003004",
                            type: "String",
                            lngTag: "20003004",
                            model: "location",
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "fa fa-map-marker"
                            },
                        },
                        {
                            label: "Wiederholung",
                            type: "Select",
                            model: "recuringType",
                            id: "recuringType",
                            dataSource: "getRecurringTypes",
                            disabled: "disableRecurring",
                            lngTag: '20018052',
                            style: {
                                class: "col-md-3 col-xs-12"
                            }
                        },
                        {
                            label: "Wiederholen bis",
                            id: "recurringEndDate",
                            placeholder: "Wiederholen bis",
                            placeholderTag: "20018053",
                            type: "Date",
                            model: "rangeDateTo",
                            lngTag: '20018053',
                            startDate: new Date(),
                            disabled: "disableRecurringEndDate",
                            style: {
                                icon: "fa fa-font",
                                class: "col-md-3 col-xs-12"
                            }
                        },
                        {
                            label: "Bemerkung",
                            placeholder: "Bemerkung eingeben ...",
                            placeholderTag: "20000049",
                            type: "Textarea",
                            maxLength: -1,
                            lngTag: "20000049",
                            model: "description",
                            style: {
                                icon: "qm-icon-note_text",
                                class: "colm-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Privat",
                            type: "Checkbox",
                            model: "isPrivate",
                            lngTag: "20018014",
                            style: {
                                class: "col-md-4 col-xs-12"
                            }
                        },
                        {
                            label: "Erledigt",
                            type: "Checkbox",
                            model: "isFinished",
                            lngTag: "20000120",
                            style: {
                                class: "col-md-4 col-xs-12"
                            }
                        },
                        {
                            label: "Ganztägig",
                            type: "Checkbox",
                            model: "isAllDay",
                            lngTag: "20018016",
                            style: {
                                class: "col-md-4 col-xs-12"
                            }
                        },
                        {
                            label: "Erinnerung Aktiv",
                            type: "Checkbox",
                            model: "reminder",
                            lngTag: "20018530",
                            style: {
                                class: "col-xs-12 col-md-2"
                            }
                        },
                        {
                            label: "Anzahl",
                            lngTag: "20000123",
                            type: "Number",
                            model: "reminderAmount",
                            style: {
                                class: "col-xs-4 col-md-4"
                            },
                            events: {
                                hideExpression: "!(qmForm.reminder)"
                            }
                        },
                        {
                            label: "Einheit",
                            type: "Select",
                            model: "reminderUnit",
                            dataSource: "getReminderUnits",
                            lngTag: '20000096',
                            style: {
                                class: "col-md-6 col-xs-8"
                            },
                            events: {
                                hideExpression: "!(qmForm.reminder)"
                            }
                        }
                    ],
                    actions: {
                        put: "putAppointment",
                        post: "addAppointment",
                        delete: "deleteAppointment"
                    }
                };
                return _this;
            }
            /**
             * return the device default view
             *
             * @public
             * @returns {string}
             *
             * @memberOf TerminListController
             */
            UserInterface.prototype.deviceDefault = function () {
                if (localStorage.getItem('calendarView') !== null)
                    return localStorage.getItem('calendarView');
                if (QMC.Common.Constants.IS_MOBILE)
                    return 'agendaDay';
                return 'agendaWeek';
            };
            UserInterface.prototype.formatListDates = function () {
                $('.fc-list-heading').each(function (index) {
                    $(this).find(".fc-list-heading-alt").text(moment($(this).attr('data-date')).format('DD.MM.YYYY'));
                });
                $('.fc-list-item').each(function (index) {
                    var time = $(this).find(".fc-list-item-time").text();
                    if (time === "Ganztägig")
                        return;
                    if (time.split('-')[1] !== undefined)
                        time = moment(time.split(" - ")[0], 'h:mma').format('HH:mm') + ' - ' + moment(time.split(" - ")[1], 'h:mma').format('HH:mm');
                    else
                        time = moment(time, 'h:mma').format('HH:mm');
                    $(this).find(".fc-list-item-time").text(time);
                });
            };
            UserInterface.prototype.detailLink = function (event, wholeSerie /* if the event is recurring the user is asked if he/she wants to edit only the event clicked or the whole event*/) {
                if (event.appointmentType !== 401000)
                    return "#/appointment";
                return "#/appointment/appointment/" +
                    (event.isRecurring ? event.mid : event.objectId) + "/" +
                    event.isRecurring + "/" + event.participantObjectId + "/" +
                    event.dateFrom + "/" +
                    ((event.start) ? moment(event.start._d).toISOString() : 0) + "/" +
                    ((event.end) ? moment(event.end._d).toISOString() : ((event.start !== undefined) ? moment(event.start._d).toISOString() : 0)) +
                    "/" + wholeSerie + "/" + event.permFlag;
            };
            return UserInterface;
        }(QMC.Common.UserInterface));
        Termin.UserInterface = UserInterface;
    })(Termin = QMC.Termin || (QMC.Termin = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Termin;
    (function (Termin) {
        var TerminListController = /** @class */ (function () {
            /**
             * Creates an instance of TerminListController.
             * @param {TerminService} terminService
             * @param {any} $qui
             * @param {Fachleistung.FlsService} flsService
             * @param {Klient.KlientService} clientService
             * @param {any} $state
             * @param {any} $scope
             * @param {Common.QmcLanguageService} lng
             * @param {any} $rootScope
             * @param {StammdatenService} stammdatenService
             *
             * @memberOf TerminListController
             */
            function TerminListController(terminService, $qui, flsService, clientService, $state, $scope, $timeout, lng, userService, $rootScope, $location, permissionService, $stateParams, taskService, stammdatenService) {
                var _this = this;
                this.terminService = terminService;
                this.$qui = $qui;
                this.flsService = flsService;
                this.clientService = clientService;
                this.$state = $state;
                this.$scope = $scope;
                this.$timeout = $timeout;
                this.lng = lng;
                this.userService = userService;
                this.$rootScope = $rootScope;
                this.$location = $location;
                this.permissionService = permissionService;
                this.$stateParams = $stateParams;
                this.taskService = taskService;
                this.stammdatenService = stammdatenService;
                this.filterText = '';
                this.ui = new Termin.UserInterface();
                this.reccuring = new Termin.RecurringOptions();
                this.calendarList = [];
                this.calendarList2 = [];
                this.shareablePersonListChanges = [];
                this.selectedCalendarType = 120000;
                this.formState = 'new';
                this.requestLock = false;
                this.disableCheckboxes = false;
                this.appointmentTypesToShow = [
                    401000,
                    401010 // Planned fls
                ];
                this.holidayUserSettings = [];
                this.eventCache = [];
                this.selectedTypes = true;
                this.promptOptionsTask = {
                    title: '',
                    icon: 'qm-icon-clipboard_check_edit',
                    yesNo: true,
                    id: 'promptTask',
                    text: this.lng.translate(20014023, 'Wollen Sie diese Aufgabe als erledigt makieren?')
                };
                this.promptChangeRecurringTerminDate = {
                    title: '',
                    icon: 'qm-icon-clipboard_check_edit',
                    yesNo: true,
                    id: 'promptChangeRecurringDate',
                    text: this.lng.translate(20018539, 'Wenn Sie alle Datumsangaben ändern möchten, öffnen Sie die Terminserie. Möchten Sie die ganze Serie bearbeiten?')
                };
                this.isGettingData = false;
                this.isWidget = false;
                this.appointmentObjectPermissions = {
                    delete: false,
                    modify: false,
                    new: false
                };
                this.lastRequest = {};
                this.slotDuration = 30;
                this.calendarName = 'calendar';
                /**
                 * get list of specific reccuring types
                 *
                 * @private
                 *
                 * @memberOf TerminListController
                 */
                this.getRecurringTypes = function () { return _this.reccuring.reccuringSelectList; };
                this.getReminderUnits = function () { return _this.reminderUnits; };
                /**
                 * get the personal calendar
                 *
                 * @private
                 *
                 * @memberOf TerminListController
                 */
                this.firstLoad = true;
                this.dblClick = null;
                this.clickTimer = null;
                if (document.getElementById("permissions").getAttribute("appointment").toLocaleLowerCase() !== "true") {
                    console.log("No rights to see module appointment");
                    this.forbidden = true;
                    return;
                }
                $("#" + this.calendarName).fullCalendar('removeEvents');
                $("#" + this.calendarName).fullCalendar('removeEventSources');
                this.isWidget = false;
                this.mobile = this.ui.isMobile();
                this.initForm();
                this.getCalendarList();
                this.getShareablePersonList();
                this.getCalenderTypeList();
                this.getAccessibleCalendarList(this.selectedCalendarType);
                this.$timeout = $timeout;
                this.reminderUnits = [
                    { value: 0, text: this.lng.translate(20000247, 'Minuten') },
                    { value: 1, text: this.lng.translate(20000219, 'Stunden') },
                    { value: 2, text: this.lng.translate(20000245, 'Tage') },
                    { value: 3, text: this.lng.translate(20000246, 'Monate') }
                ];
                this.promptOptions = {
                    title: this.lng.translate(20018050, "Serientermin"),
                    icon: "qm-icon-calendar_7",
                    id: "prompt-change",
                    fields: [
                        {
                            text: this.lng.translate(20018051, 'Wollen Sie diesen Termin oder die ganze Serie bearbeiten?'), name: 'wholeSeries',
                            options: [{ text: this.lng.translate(20018044, "Dieser Termin"), value: false }, { text: this.lng.translate(20018045, "Alle Termine dieser Serie"), value: true }]
                        }
                    ]
                };
                var storageObject = window.localStorage.getItem(QMC.Common.LocalStorageConstants.APPOINTMENT_TYPES_TO_SHOW);
                if (storageObject && storageObject !== "")
                    this.appointmentTypesToShow = storageObject.split(",").map(Number);
                flsService.getCasesList().then(function (data) {
                    _this.cases = data;
                    _this.caseList = $qui.select(data, { value: 'internalName', text: 'internalName' });
                    _this.resetData();
                });
                this.$scope.$watch('vm.form.recuringType', function () {
                    if (_this.form.recuringType > 0 && _this.form.recuringType !== null && _this.form.disableRecurring === false) {
                        _this.form.disableRecurringEndDate = false;
                        _this.form.rangeDateFrom = _this.form.dateFrom;
                        _this.form.rangeDateTo = _this.form.dateTo;
                        _this.form.isRecurring = true;
                    }
                    else {
                        _this.form.disableRecurringEndDate = true;
                        _this.form.isRecurring = _this.form.recuringType !== null;
                        _this.form.rangeDateTo = null;
                    }
                });
                this.userService.getUserSettings(['TERMINPLAN.FERIEN.VISIBLE', 'TERMINPLAN.FEIERTAGE.VISIBLE', 'WEBCLIENT.CALENDAR.SLOTDURATION'], false).then(function (settings) {
                    _this.slotDuration = settings[2].value && settings[2].value.length > 0 ? parseInt(settings[2].value) : _this.slotDuration;
                    _this.holidayUserSettings = settings;
                    _this.terminService.getAppointmentTypes().then(function (data) {
                        for (var type in data)
                            data[type].state = _this.appointmentTypesToShow.indexOf(data[type].typeId) >= 0;
                        var ferien = {
                            typeId: 1,
                            name: 'Ferien',
                            colorHtml: '#DBDBDB',
                            state: _this.holidayUserSettings[0].value === "true",
                        };
                        var feiertage = {
                            typeId: 2,
                            name: 'Feiertage',
                            colorHtml: '#DBDBDB',
                            state: _this.holidayUserSettings[1].value === "true",
                        };
                        data.push(feiertage);
                        data.push(ferien);
                        data.sort(function (a, b) { return (a.name.toLocaleLowerCase() > b.name.toLocaleLowerCase()) ? 1 : ((b.name.toLocaleLowerCase() > a.name.toLocaleLowerCase()) ? -1 : 0); });
                        _this.appointmentTypes = data;
                    });
                    _this.permissionService.getPermissionsByObjectType(400000).then(function (data) {
                        _this.appointmentObjectPermissions = {
                            new: data[0].new,
                            modify: data[0].new,
                            delete: data[0].delete,
                        };
                    });
                });
                this.detailState = "appointment.detail";
                $qui.init($qui.getSectionColor($location.path()), function () {
                    _this.render();
                    $qui.anonAvatar();
                    $qui.bindEvents();
                });
                this.clientService.getPersonListByObjectTypes([120000, 130000, 140000, 140006], '', true, false).then(function (data) {
                    data.map(function (item) {
                        item.displayTitle = _this.$qui.createPersonDisplay(item.displayTitle, '', item.shortCaption, item.personNumber);
                        return item;
                    });
                    _this.clientService.getAllPersonLists().then(function (dataPL) {
                        _this.clientService.getResourceList('', true).then(function (dataRes) {
                            _this.clientService.getVehicleList().then(function (dataVeh) {
                                var temp = data.map(function (x) { return ({ text: x.displayTitle, value: x.objectId, group: _this.getGroupName(x.objectType), subText: x.institute }); });
                                temp = temp.concat(dataPL.map(function (x) { return ({ text: x.name, value: x.objectId, group: _this.lng.translate(20000237, 'Personenliste'), subText: '' }); }));
                                temp = temp.concat(dataRes.map(function (x) { return ({ text: x.caption, value: x.objectId, group: _this.lng.translate(20000271, 'Ressource'), subText: x.institute }); }));
                                temp = temp.concat(dataVeh.map(function (x) { return ({ text: x.displayTitle, value: x.objectId, group: _this.lng.translate(20029006, 'Fuhrpark'), subText: x.kindOfVehicle }); }));
                                temp.sort(function (a, b) { return (a.text.toLocaleLowerCase() > b.text.toLocaleLowerCase()) ? 1 : ((b.text.toLocaleLowerCase() > a.text.toLocaleLowerCase()) ? -1 : 0); });
                                temp.sort(function (a, b) { return (a.group.toLocaleLowerCase() > b.group.toLocaleLowerCase()) ? 1 : ((b.group.toLocaleLowerCase() > a.group.toLocaleLowerCase()) ? -1 : 0); });
                                _this.participants = temp;
                            });
                        });
                        //get the organisation for the logged user
                        _this.stammdatenService.getOrganisationForPerson($('#session').data().personId).then(function (data) {
                            _this.organisationForCurrentUser = data.organisationId;
                        });
                    });
                });
            }
            TerminListController.prototype.getParticipants = function () {
                return this.participants;
            };
            TerminListController.prototype.getGroupName = function (type) {
                switch (type) {
                    case 120000:
                        return this.lng.translate(20000235, 'Mitarbeiter');
                    case 130000:
                        return this.lng.translate(20000279, 'Organisation');
                    case 140000:
                        return this.lng.translate(21002000, 'Klient');
                    case 140006:
                        return this.lng.translate(20001048, 'Kontaktperson');
                    default:
                        return '';
                }
            };
            /**
             * convert to title case
             *
             * @private
             * @param {string} str
             * @returns {string}
             *
             * @memberOf TerminListController
             */
            TerminListController.prototype.toTitleCase = function (str) {
                return str.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
            };
            /**
             * init the form with default values
             *
             * @private
             *
             * @memberOf TerminListController
             */
            TerminListController.prototype.initForm = function () {
                this.form = {
                    title: null,
                    dateFrom: moment(new Date()).startOf('hour').add(1, "hour").toDate(),
                    dateTo: moment(new Date()).startOf('hour').add(1, "hour").add(30, 'minutes').toDate(),
                    rangeDateFrom: new Date(),
                    rangeDateTo: null,
                    isAllDay: false,
                    location: null,
                    participantIds: !this.getForOrga ? [$('#session').data().personId] : [this.organisationForCurrentUser],
                    description: null,
                    isFinished: false,
                    isPrivate: false,
                    isRecurring: false,
                    recuringType: 0,
                    reminder: true,
                    reminderAmount: 15,
                    reminderUnit: 0,
                    disableRecurring: false,
                    disableRecurringEndDate: false,
                };
            };
            /**
             * get the calendar list
             *
             * @private
             *
             * @memberOf TerminListController
             */
            TerminListController.prototype.getCalendarList = function () {
                var _this = this;
                this.lastRequest = {};
                this.terminService.getCalendarList().then(function (data) {
                    _this.sharedCalendar = data;
                    _this.sharedCalendarMap = data.map(function (x) { return ({ text: x.description, value: x.personObjectId }); });
                    _this.sharedCalendarMap.sort(function (x, y) {
                        var a = x.text.toUpperCase(), b = y.text.toUpperCase();
                        if (a > b) {
                            return 1;
                        }
                        if (a < b) {
                            return -1;
                        }
                        return 0;
                    });
                    if (!data.map(function (x) { return x.personObjectId; }).includes(_this.selectedCalendar))
                        _this.selectedCalendar = undefined;
                    if (_this.selectedCalendar === (null || undefined)) {
                        _this.selectedCalendar = data[0].personObjectId;
                        for (var i = 0; i < data.length; i++)
                            if (data[i].personObjectId === $('#session').data().personId)
                                _this.selectedCalendar = data[i].personObjectId;
                    }
                    _this.calendar = data[0];
                });
            };
            TerminListController.prototype.getDateList = function (id, dateFrom, dateTo) {
                var _this = this;
                var currentRequest = { id: id, dateFrom: dateFrom, dateTo: dateTo, types: this.appointmentTypesToShow };
                if (this.isGettingData || JSON.stringify(this.lastRequest) === JSON.stringify(currentRequest))
                    return;
                this.lastRequest = currentRequest;
                this.calendarList = [];
                $("#" + this.calendarName).fullCalendar('removeEvents');
                $("#" + this.calendarName).fullCalendar('removeEventSource', this.calendarList);
                $("#" + this.calendarName).fullCalendar('removeEventSources');
                this.isGettingData = true;
                this.loading = true;
                if (this.isWidget) {
                    this.userService.getUserSettings(['APPOINTMENT.WIDGET.ORGA', 'APPOINTMENT.WIDGET.DAYSTOPAST', 'APPOINTMENT.WIDGET.DAYSTOFUTURE']).then(function (data) {
                        _this.getForOrga = data[0].value.toLowerCase() === 'true';
                        var daysToPast = data[1].value.length > 0 ? parseInt(data[1].value) : 0;
                        var daysToFuture = data[2].value.length > 0 && parseInt(data[2].value) > 0 ? parseInt(data[2].value) : 7 - moment().isoWeekday();
                        _this.viewDateFrom = moment().startOf('day').add(-daysToPast, 'd').toDate();
                        _this.viewDateTo = moment().endOf('day').add(daysToFuture, 'd').toDate();
                        _this.getData(id, _this.viewDateFrom, _this.viewDateTo, _this.getForOrga);
                    });
                }
                else {
                    this.$timeout(function () {
                        _this.getData(id, dateFrom, dateTo, _this.getForOrga);
                    });
                }
            };
            TerminListController.prototype.getData = function (id, dateFrom, dateTo, getOrga) {
                var _this = this;
                if (getOrga === void 0) { getOrga = false; }
                this.terminService.getAppointmentList(id, dateFrom, dateTo, this.appointmentTypesToShow, getOrga).then(function (data) {
                    //Feiertage
                    _this.terminService.getHolidaysSpecific(_this.calculateCurrentYearOfCalender(dateFrom, dateTo), _this.appointmentTypesToShow.some(function (x) { return x === 2; }), _this.appointmentTypesToShow.some(function (x) { return x === 1; })).then(function (holidays) {
                        _this.$qui.functionWaiter("ui.createForm", _this);
                        _this.isGettingData = false;
                        _this.loading = false;
                        for (var i = 0; i < holidays.length; i++) {
                            holidays[i].allDay = true;
                            holidays[i].title = holidays[i].caption;
                            holidays[i].editable = false;
                            holidays[i].color = "#DBDBDB";
                            holidays[i].start = moment(holidays[i].dateFrom);
                            holidays[i].end = moment(holidays[i].dateTo);
                            _this.calendarList.push(holidays[i]);
                        }
                        _this.eventCache = [];
                        if (data[0] !== undefined)
                            if (data[0].objectId.toString().length > 1) {
                                for (var i = 0; i < data.length; i++) {
                                    _this.calendarList.push(_this.ui.createCalendarEvent(data[i], (data[i].appointmentTypeId === 840501 ||
                                        data[i].appointmentTypeId === 411010 ||
                                        data[i].appointmentTypeId === 401000) ? null : _this.$qui.generateGuid(), _this.appointmentTypes));
                                }
                                _this.eventCache = angular.copy(_this.calendarList);
                            }
                        $("#" + _this.calendarName).fullCalendar('addEventSource', _this.calendarList);
                        _this.loading = false;
                        if (_this.isWidget)
                            _this.widgetRender(_this.calendarList);
                        else
                            _this.setupCalendar();
                    });
                });
            };
            TerminListController.prototype.resetCalendar = function () {
                $("#" + this.calendarName).fullCalendar('removeEvents');
                $("#" + this.calendarName).fullCalendar('removeEventSource', this.calendarList);
                $("#" + this.calendarName).fullCalendar('removeEventSources');
                $("#" + this.calendarName).fullCalendar('addEventSource', this.calendarList);
                $("#" + this.calendarName).fullCalendar('refetchEvents');
                $("#" + this.calendarName).fullCalendar('rerenderEvents');
            };
            TerminListController.prototype.calculateCurrentYearOfCalender = function (dateFrom, dateTo) {
                var To = this.$qui.createDateFromString(dateTo);
                var From = this.$qui.createDateFromString(dateFrom);
                var year = (To.getMonth() - From.getMonth() >= 0) ? To.getFullYear() : From.getFullYear();
                return year;
            };
            /**
             * Rendering of the Widget Calendar
             *
             * @returns
             *
             * @memberof TerminListController
             */
            TerminListController.prototype.widgetRender = function (calEvents) {
                return null;
            };
            /**
             * add an array of events to personal calendar
             *
             * @private
             * @param {*} arr
             *
             * @memberOf TerminListController
             */
            TerminListController.prototype.addToPersonalCalendar = function (arr) {
                var _this = this;
                $("#" + this.calendarName).fullCalendar('removeEvents');
                this.calendarList2 = [];
                setTimeout(function () {
                    _this.terminService.getAppointmentList(arr.personObjectId, _this.form.dateFrom, _this.form.dateTo, _this.appointmentTypesToShow).then(function (data) {
                        for (var i = 0; i < data.length; i++) {
                            if (data[0].objectId.toString().length > 1) {
                                _this.calendarList2.push(_this.ui.createCalendarEvent(data[i]));
                            }
                        }
                        $("#" + _this.calendarName).fullCalendar('addEventSource', _this.calendarList2);
                        _this.setupCalendar();
                    });
                }, 500);
            };
            /**
             * add a new appointment
             *
             * @private
             * @param {*} form is modified IAppointmentCreate, to inject participants!
             *
             * @memberOf TerminListController
             */
            TerminListController.prototype.addAppointment = function (form) {
                var _this = this;
                if (form.recuringType > 0) {
                    form.isRecurring = true;
                    form.recurrenceOptions = this.reccuring.getOptions(Number(form.recuringType), form.dateFrom);
                    form.recurrenceOptions.rangeDateFrom = form.dateFrom;
                    this.reccuring.setRangeLimit(0);
                    if (form.rangeDateTo !== null) {
                        form.recurrenceOptions.rangeDateTo = form.rangeDateTo;
                        this.reccuring.setRangeLimit(2);
                    }
                }
                this.validateAppointment(form);
                this.validationCallback = function (form) {
                    $('#edit-form').modal('hide');
                    _this.terminService.postAppointment(form).then(function () {
                        console.log("Form", form);
                        _this.ui.notify(_this.ui.successNote);
                        _this.formState = 'new';
                        _this.resetData();
                    });
                };
            };
            /**
             * when a event on the fullcalendar has changed
             *
             * @private
             * @param {any} id
             * @param {any} data
             *
             * @memberOf TerminListController
             */
            TerminListController.prototype.changeEvents = function (id, isRecurring, participantId, dateFrom, data) {
                var _this = this;
                if (isRecurring) {
                    QMC.Common.Utilities.confirm(this.promptOptions, function (prompt) {
                        if (prompt)
                            _this.modifyEvents(id, isRecurring, participantId, dateFrom, data, prompt.wholeSeries);
                        else
                            _this.resetCalendar();
                    }, '#prompto');
                }
                else {
                    this.modifyEvents(id, isRecurring, participantId, dateFrom, data);
                }
            };
            TerminListController.prototype.modifyEvents = function (id, isRecurring, participantId, dateFrom, data, wholeSeries) {
                var _this = this;
                if (wholeSeries === void 0) { wholeSeries = false; }
                if (id !== undefined) {
                    this.loading = true;
                    if (!(data.permissions.modify)) {
                        this.$qui.notify({
                            message: this.lng.translate(20002034, "Keine Berechtigung für diesen Datensatz."),
                            title: "Fehler",
                            icon: "qm-icon-error",
                            status: "warning",
                            timer: 3500
                        });
                        this.resetData();
                        return;
                    }
                    if (data.dateTo === null)
                        data.dateTo = data.dateFrom;
                    data.dateFrom = moment(data.dateFrom).toDate();
                    data.dateTo = moment(data.dateTo).toDate();
                    data.mainAppointmentId = id;
                    data.participantIds = [participantId];
                    data.changeDatesOnly = true;
                    this.validateAppointment(data);
                    this.validationCallback = function () {
                        _this.terminService.putAppointment(id, isRecurring, participantId, dateFrom, wholeSeries, data, isRecurring && _this.dayChanged(id, data.dateFrom)).then(function () {
                            _this.$qui.notify(_this.$qui.successNote);
                            _this.resetData();
                        });
                    };
                }
            };
            TerminListController.prototype.getOriginalDate = function (id, getDateFrom) {
                if (getDateFrom === void 0) { getDateFrom = true; }
                for (var _i = 0, _a = this.eventCache; _i < _a.length; _i++) {
                    var event_1 = _a[_i];
                    if (event_1.objectId === id) {
                        return getDateFrom ? moment(event_1.start) : moment(event_1.end);
                    }
                }
                return null;
            };
            TerminListController.prototype.dayChanged = function (id, date) {
                for (var _i = 0, _a = this.eventCache; _i < _a.length; _i++) {
                    var event_2 = _a[_i];
                    if (event_2.objectId === id) {
                        return moment(event_2.dateFrom).isoWeekday() !== moment(date).isoWeekday();
                    }
                }
                return false;
            };
            TerminListController.prototype.getPersonalCalendar = function (view) {
                var _this = this;
                if (view !== null)
                    localStorage.setItem('calendarView', view.name);
                this.setViewDates();
                //$(`#${this.calendarName}`).fullCalendar('removeEvents'); //Why was this here? removed for Q3W-232
                this.requestLock = true;
                this.terminService.getCalendarList().then(function (data) {
                    if (!_this.requestLock)
                        return;
                    _this.requestLock = false;
                    if (data.length > 0) {
                        _this.getDateList(_this.selectedCalendar, _this.viewDateFrom, _this.viewDateTo);
                        if (_this.personalCalendar === undefined)
                            _this.personalCalendar = data;
                    }
                });
            };
            /**
             * reset the fullcalendar data, get new
             *
             * @public
             *
             * @memberOf TerminListController
             */
            TerminListController.prototype.resetData = function () {
                //this.calendarList = [];
                this.loading = true;
                this.lastRequest = {};
                this.getPersonalCalendar(null);
                this.getDateList(this.selectedCalendar, this.viewDateFrom, this.viewDateTo);
            };
            /**
             * render the fullcalendar
             *
             * @private
             *
             * @memberOf TerminListController
             */
            TerminListController.prototype.render = function () {
                var _this = this;
                this.$scope.$watch('vm.selectedCalendar', function (oldVal, newVal) {
                    if (oldVal !== newVal && oldVal !== undefined) {
                        _this.resetData();
                        _this.form.participantIds = [_this.selectedCalendar];
                        if (_this.selectedCalendar !== $('#session').data().personId) {
                            _this.form.participantIds.push($('#session').data().personId);
                        }
                    }
                });
                this.$scope.$watch('vm.appointmentTypes', function (oldVal, newVal) {
                    if (oldVal !== newVal && oldVal !== undefined) {
                        _this.disableCheckboxes = true;
                        setTimeout(function () { _this.disableCheckboxes = false; }, 1000); //coldfix
                        _this.appointmentTypesToShow = [];
                        for (var type in _this.appointmentTypes) {
                            var currentType = _this.appointmentTypes[type];
                            if (currentType.state) {
                                _this.appointmentTypesToShow.push(currentType.typeId);
                            }
                            if (currentType.name === 'Ferien') {
                                _this.userService.setUserSettings({ settings: [{ key: 'TERMINPLAN.FERIEN.VISIBLE', value: currentType.state }] }, false);
                            }
                            if (currentType.name === 'Feiertage') {
                                _this.userService.setUserSettings({ settings: [{ key: 'TERMINPLAN.FEIERTAGE.VISIBLE', value: currentType.state }] }, false);
                            }
                        }
                        if (_this.disableCheckboxes)
                            _this.resetData();
                        console.log('#### appTypesToShow: ', _this.appointmentTypesToShow);
                        //save selection in storage
                        if (_this.appointmentTypesToShow.length > 0)
                            window.localStorage.setItem(QMC.Common.LocalStorageConstants.APPOINTMENT_TYPES_TO_SHOW, _this.appointmentTypesToShow.toString());
                    }
                }, true);
                setTimeout(function () {
                    $("#" + _this.calendarName).fullCalendar('render');
                }, 500);
            };
            /**
             * get the height for the fullcalendar by device
             *
             * @private
             * @returns {number}
             *
             * @memberOf TerminListController
             */
            TerminListController.prototype.getHeight = function () {
                if ($('body').hasClass('mobile'))
                    return 350;
                return 650;
            };
            /**
             * set the view dates for the fullcalendar
             *
             * @private
             *
             * @memberOf TerminListController
             */
            TerminListController.prototype.setViewDates = function () {
                if (this.isWidget) {
                    this.viewDateFrom = moment(new Date()).format();
                    this.viewDateTo = moment(new Date()).endOf('week').format();
                    return;
                }
                ;
                var dateFrom = $("#" + this.calendarName).fullCalendar('getView').start;
                var dateTo = $("#" + this.calendarName).fullCalendar('getView').end;
                if (typeof dateFrom !== "object")
                    dateFrom = new Date();
                if (typeof dateTo !== "object")
                    dateTo = new Date();
                this.viewDateFrom = moment(dateFrom).startOf('week').format();
                this.viewDateTo = moment(dateTo).endOf('week').add(1, 'day').format();
            };
            /**
    * Returns a qmc calendar event which can be shown in the calendar
    * @param appointment The appointment object
    */
            TerminListController.prototype.createCalendarEvent = function (appointment) {
                var event = {};
                event.id = appointment.objectId;
                event.objectId = appointment.objectId;
                event.mid = appointment.mainAppointmentId;
                event.title = appointment.title;
                event.start = moment(appointment.dateFrom);
                event.end = moment(appointment.dateTo);
                event.allDay = appointment.isAllDay;
                event.isFinished = appointment.isFinished;
                event.isPrivate = appointment.isPrivate;
                event.isRecurring = appointment.isRecurring;
                event.isTypeAppointment = appointment.isTypeAppointment;
                event.editable = true;
                event.color = appointment.colorHtml;
                event.iconCode = "";
                event.recurrenceSettings = appointment.recurrenceSettings;
                if (event.isFinished) {
                    event.iconCode += "<i class='fa fa-check'></i> ";
                }
                if (event.isPrivate) {
                    event.iconCode += "<i class='fa fa-lock'></i> ";
                }
                if (event.isRecurring) {
                    event.iconCode += "<i class='fa fa-refresh'></i> ";
                    event.editable = false;
                }
                if (event.isDeleted) {
                    event.iconCode += "<i class='fa fa-trash'></i> ";
                }
                if (!event.isTypeAppointment) {
                    event.editable = false;
                }
                return event;
            };
            TerminListController.prototype.getAppointmentObject = function (id) {
                for (var i = 0; i < this.calendarList.length; i++) {
                    var objAppointment = this.calendarList[i];
                    if (objAppointment.id === id) {
                        return objAppointment;
                    }
                }
                return null;
            };
            /**
             * configuration for the fullcalendar
             *
             * @private
             *
             * @memberOf TerminListController
             */
            TerminListController.prototype.setupCalendar = function () {
                var _this = this;
                var _a;
                var allDayText = this.lng.translate(20018016, "Ganztägig");
                // height was : "contentHeight: this.getHeight(),"
                $("#" + this.calendarName).fullCalendar({
                    schedulerLicenseKey: QMC.Common.Constants.FULL_CALENDAR_PREMIUM_LICENSE,
                    defaultTimedEventDuration: '00:30:00',
                    contentHeight: window.innerHeight - 250,
                    defaultView: (_a = this.$stateParams.view) !== null && _a !== void 0 ? _a : this.ui.deviceDefault(),
                    allDayText: allDayText,
                    timezone: "local",
                    allDaySlot: true,
                    slotLabelFormat: 'H:mm',
                    slotDuration: this.$qui.timeStringFromHours(this.slotDuration),
                    events: this.calendarList,
                    firstDay: 1,
                    monthNames: this.lng.translate(20018519, 'Januar,Februar,März,April,Mai,Juni,Juli,August,September,Oktober,November,Dezember').split(','),
                    monthNamesShort: this.lng.translate(20018520, 'Jan,Feb,Mrz,Apr,Mai,Jun,Jul,Aug,Sep,Okt,Nov,Dez').split(','),
                    dayNames: this.lng.translate(20018521, 'Sonntag,Montag,Dienstag,Mittwoch,Donnerstag,Freitag,Samstag').split(','),
                    dayNamesShort: this.lng.translate(20018522, 'So.,Mo.,Di.,Mi.,Do.,Fr.,Sa.').split(','),
                    weekNumbers: true,
                    weekNumberCalculation: function (date) { return moment(date).isoWeek(); },
                    nowIndicator: true,
                    views: {
                        month: {
                        //titleFormat: 'MMMM yyyy'
                        },
                        week: {
                            titleFormat: 'dddd, D MMM YYYY'
                        },
                        day: {
                            titleFormat: 'dddd D.MM'
                        }
                    },
                    buttonText: {
                        today: this.lng.translate(20000126, 'Heute'),
                        month: this.lng.translate(20000115, 'Monat'),
                        week: this.lng.translate(20000114, 'Woche'),
                        day: this.lng.translate(20000041, 'Tag')
                    },
                    viewRender: function (view, element) {
                        _this.$state.go('.', {
                            startDay: _this.$qui.createDateFromString($("#" + _this.calendarName).fullCalendar('getView').start).toISOString(),
                            view: $("#" + _this.calendarName).fullCalendar('getView').name
                        });
                        _this.getPersonalCalendar(view);
                    },
                    columnFormat: 'ddd D.M',
                    timeFormat: 'H:mm',
                    header: {
                        left: 'prev,next today',
                        center: 'title',
                        right: 'month, agendaWeek, agendaDay'
                    },
                    editable: true,
                    droppable: true,
                    eventRender: function (event, element) {
                        $(element).find(".fc-title").prepend(event.iconCode);
                    },
                    eventResize: function (event) {
                        var newForm = {
                            dateFrom: event.start,
                            dateTo: event.end,
                            title: event.title,
                            isAllDay: event.allDay,
                            changeDatesOnly: true
                        };
                        _this.changeEvents(event.isRecurring ? event.mid : event.objectId, event.isRecurring, event.participantObjectId, event.start, newForm);
                    },
                    eventDrop: function (event, detla, revert) {
                        var objAppointment = _this.getAppointmentObject(event.id);
                        var newForm = {
                            dateFrom: event.start,
                            dateTo: event.end,
                            title: event.title,
                            isAllDay: event.allDay,
                            changeDatesOnly: true,
                            recurrenceChangeDateFrom: _this.getOriginalDate(event.isRecurring ? event.mid : event.objectId),
                            recurrenceChangeDateTo: _this.getOriginalDate(event.isRecurring ? event.mid : event.objectId, false),
                            appointmentTypeId: _this.appointment != null ? objAppointment.appointmentTypeId : event.appointmentType,
                            location: _this.appointment != null ? objAppointment.location : event.location,
                            isTypeAppointment: _this.appointment != null ? objAppointment.isTypeAppointment : event.isTypeAppointment,
                            isFinished: _this.appointment != null ? objAppointment.isFinished : event.isFinished,
                            description: _this.appointment != null ? objAppointment.description : event.description,
                            isPrivate: _this.appointment != null ? objAppointment.isPrivate : event.isPrivate,
                            isManual: _this.appointment != null ? objAppointment.isManual : event.isManual,
                            isRecurring: _this.appointment != null ? objAppointment.isRecurring : event.isRecurring,
                            isDeleted: _this.appointment != null ? objAppointment.isDeleted : event.isDeleted,
                            colorHtml: _this.appointment != null ? objAppointment.colorHtml : event.color,
                            recurrenceSettings: _this.appointment != null ? objAppointment.recurrenceSettings : event.recurrenceSettings,
                            permissions: event.permissions
                        };
                        if ((event.isRecurring && moment(event.start).format('YYYY-MM-DD') === event.dateFrom) || (!event.isRecurring)) {
                            _this.calendarList = [];
                            _this.changeEvents(event.isRecurring ? event.mid : event.objectId, event.isRecurring, event.participantObjectId, event.start, newForm);
                        }
                        else {
                            _this.promptChangeRecurringTerminDate.title = event.title;
                            _this.$qui.scopeApply(_this.$scope);
                            QMC.Common.Utilities.confirm(_this.promptChangeRecurringTerminDate, function (result) {
                                if (result) {
                                    location.hash = _this.ui.detailLink(event, true);
                                }
                                else {
                                    _this.resetCalendar();
                                }
                            }, '#promptChangeRecurringDate');
                        }
                    },
                    drop: function () {
                    },
                    aspectRatio: 5,
                    eventClick: function (event) {
                        if (event.appointmentType === 840501) {
                            if (event.isFinished)
                                _this.$state.go("tasksdetail", { id: event.mainAppointmentId });
                            else {
                                _this.promptOptionsTask.title = event.title;
                                _this.$qui.scopeApply(_this.$scope);
                                QMC.Common.Utilities.confirm(_this.promptOptionsTask, function (result) {
                                    if (result) {
                                        _this.taskService.setFinishedState(event.mainAppointmentId, true, moment().format('YYYY-MM-DD')).then(function () {
                                            _this.$qui.notify(_this.$qui.successNote);
                                            _this.resetData();
                                        });
                                    }
                                    else {
                                        _this.$state.go("tasksdetail", { id: event.mainAppointmentId });
                                    }
                                }, '#promptTask');
                            }
                        }
                        else if (event.appointmentType === 411010) {
                            localStorage.setItem(QMC.Common.LocalStorageConstants.AZN_PREVIOUS_STATE, JSON.stringify({
                                state: _this.$state.$current.name,
                                params: _this.$state.$current.name
                            }));
                            _this.$state.go('azndetail', { "id": event.id });
                        }
                        else if (event.appointmentType === 401008) {
                            $('#unsupportedAppointmentTypeModal').modal('show');
                        }
                        else if (event.editable) {
                            if (event.end === undefined || event.end === null)
                                event.end = event.start;
                            var path_1 = _this.ui.detailLink(event, !event.isRecurring);
                            if (event.isRecurring) {
                                _this.promptOptions.title = event.title;
                                _this.$qui.scopeApply(_this.$scope);
                                QMC.Common.Utilities.confirm(_this.promptOptions, function (prompt) {
                                    if (prompt) {
                                        if (location.hash !== path_1)
                                            location.hash = _this.ui.detailLink(event, prompt.wholeSeries);
                                        else {
                                            location.hash = '#/appointment';
                                            setTimeout(function () {
                                                location.hash = _this.ui.detailLink(event, prompt.wholeSeries);
                                            }, 500);
                                        }
                                    }
                                }, '#prompto');
                            }
                            else {
                                if (location.hash !== path_1)
                                    location.hash = _this.ui.detailLink(event, false);
                                else {
                                    location.hash = '#/appointment';
                                    setTimeout(function () {
                                        location.hash = _this.ui.detailLink(event, false);
                                    }, 500);
                                }
                            }
                        }
                    },
                    dayClick: function (date, jsEvent, view) {
                        var singleClick = moment(date).toISOString();
                        if (_this.dblClick === singleClick) {
                            if (_this.appointmentObjectPermissions.new) {
                                $("#edit-form").modal("toggle");
                                _this.form.dateFrom = moment(date).toDate();
                                _this.form.dateTo = moment(date).add('minutes', 30).toDate();
                                _this.form.rangeDateFrom = moment(date).toDate();
                                _this.form.disableRecurringEndDate = true;
                                _this.$qui.scopeApply(_this.$scope);
                            }
                            _this.dblClick = null;
                        }
                        else {
                            _this.dblClick = moment(date).toISOString();
                            clearInterval(_this.clickTimer);
                            _this.clickTimer = setInterval(function () {
                                this.dblClick = null;
                                clearInterval(this.clickTimer);
                            }, 500);
                        }
                        if (view.name === 'month') {
                            $("#" + _this.calendarName).fullCalendar('gotoDate', date);
                            $("#" + _this.calendarName).fullCalendar('changeView', 'agendaWeek');
                        }
                    }
                });
                if (this.firstLoad && !this.isWidget && this.$stateParams.startDay) {
                    this.firstLoad = false;
                    var dateMoment = moment(this.$stateParams.startDay);
                    if (this.$stateParams.view === 'month' && dateMoment.date() > 24)
                        dateMoment = dateMoment.add(1, 'month').startOf('month');
                    $("#" + this.calendarName).fullCalendar('gotoDate', dateMoment.toDate());
                }
            };
            TerminListController.prototype.getShareablePersonList = function () {
                var _this = this;
                this.terminService.getShareablePersonList().then(function (data) {
                    _this.shareablePersonList = data;
                });
            };
            TerminListController.prototype.getAccessibleCalendarList = function (selectedCalendarType) {
                var _this = this;
                this.loadingAccessibleCalendarList = true;
                this.terminService.getAccessibleCalenderList(selectedCalendarType).then(function (data) {
                    _this.accessibleCalendarList = data;
                    _this.loadingAccessibleCalendarList = false;
                });
            };
            TerminListController.prototype.getCalenderTypeList = function () {
                var _this = this;
                this.terminService.getCalendarTypeList().then(function (data) {
                    _this.calendarTypeList = data;
                    _this.calendarTypeListMap = _this.$qui.selectAutoMap(data, 'objectType', 'caption');
                });
                this.$scope.$watch('vm.selectedCalendarType', function (newVal, oldVal) {
                    if (newVal === oldVal)
                        return;
                    _this.calendarTypeChanged();
                });
            };
            TerminListController.prototype.calendarTypeChanged = function () {
                this.getAccessibleCalendarList(this.selectedCalendarType);
            };
            TerminListController.prototype.shareablePersonListItemChanged = function (changedItem) {
                this.shareablePersonListChanges.push(changedItem);
            };
            TerminListController.prototype.putAccessible = function () {
                var _this = this;
                $('#addCalenderModal').modal('hide');
                this.loadingAccessibleCalendarList = true;
                this.terminService.putAccessible(this.accessibleCalendarList).then(function () {
                    _this.getAccessibleCalendarList(_this.selectedCalendarType);
                    _this.getCalendarList();
                    if (_this.selectedCalendarType === 130000)
                        _this.getDateList(_this.selectedCalendar, _this.viewDateFrom, _this.viewDateTo);
                });
            };
            TerminListController.prototype.putShareOwnCalender = function (item) {
                var _this = this;
                $('#enableCalenderModal').modal('hide');
                var list = this.shareablePersonListChanges.map(function (item) { return { userId: item.userObjectId, canView: item.canView, canCreateModify: item.canCreateModify, canDelete: item.canDelete }; });
                this.terminService.putShareOwnCalendar(list).then(function () {
                    _this.shareablePersonListChanges = [];
                    _this.getShareablePersonList();
                });
            };
            TerminListController = __decorate([
                QMC.Controller('QMC.Termin', 'TerminListController'),
                QMC.Inject('TerminService', '$qui', 'FachleistungService', 'KlientService', '$state', '$scope', '$timeout', 'QmcLanguageService', 'UserService', '$rootScope', '$location', 'QmcPermissionService', '$stateParams', 'AufgabenService', 'StammdatenService')
            ], TerminListController);
            return TerminListController;
        }());
        Termin.TerminListController = TerminListController;
    })(Termin = QMC.Termin || (QMC.Termin = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Termin;
    (function (Termin) {
        var TerminDetailController = /** @class */ (function () {
            /**
             * Creates an instance of TerminDetailController.
             * @param {TerminService} terminService
             * @param {any} $qui
             * @param {Fachleistung.FlsService} flsService
             * @param {any} $state
             * @param {any} $stateParams
             * @param {any} $scope
             * @param {Klient.KlientService} clientService
             * @param {Common.QmcLanguageService} lng
             *
             * @memberOf TerminDetailController
             */
            function TerminDetailController(terminService, $qui, flsService, $state, $stateParams, $scope, $timeout, clientService, lng, permissionService) {
                var _this = this;
                this.terminService = terminService;
                this.$qui = $qui;
                this.flsService = flsService;
                this.$state = $state;
                this.$stateParams = $stateParams;
                this.$scope = $scope;
                this.$timeout = $timeout;
                this.clientService = clientService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.ui = new Termin.UserInterface();
                this.calendarList = [];
                this.formState = 'new';
                this.appointmentTypesToShow = [
                    401000,
                    401010 // Fls
                ];
                this.promptOptions = {};
                this.reccuring = new Termin.RecurringOptions();
                this.permissions = {
                    delete: false,
                    modify: false,
                    new: true
                };
                this.loadingSemaphor = false;
                this.participants = [];
                this.loading = { participants: false, appointment: false, calendar: false };
                /**
                 * get list of specific reccuring types
                 *
                 * @private
                 *
                 * @memberOf TerminListController
                 */
                this.getRecurringTypes = function () { return _this.reccuring.reccuringSelectList; };
                this.getReminderUnits = function () { return _this.reminderUnits; };
                if (document.getElementById("permissions").getAttribute("appointment").toLocaleLowerCase() !== "true") {
                    console.log("No rights to see module appointment");
                    this.forbidden = true;
                    return;
                }
                var storageObject = window.localStorage.getItem(QMC.Common.LocalStorageConstants.APPOINTMENT_TYPES_TO_SHOW);
                if (storageObject !== undefined && storageObject !== "")
                    this.appointmentTypesToShow = storageObject.split(",").map(Number);
                this.initForm();
                this.getDetailData();
                this.reminderUnits = [
                    { value: 0, text: this.lng.translate(20000247, 'Minuten') },
                    { value: 1, text: this.lng.translate(20000219, 'Stunden') },
                    { value: 2, text: this.lng.translate(20000245, 'Tage') },
                    { value: 3, text: this.lng.translate(20000246, 'Monate') }
                ];
                flsService.getCasesList().then(function (data) {
                    _this.cases = data;
                    _this.getPersonalCalendar();
                    _this.caseList = $qui.select(data, { value: 'internalName', text: 'internalName' });
                });
                this.$timeout = $timeout;
                this.promptOptionsAllParticipantsDelete = {
                    title: this.lng.translate(20018048, 'Wollen Sie den Termin wirklich löschen?'),
                    id: "prompt-delete",
                    icon: "qm-icon-calendar_7",
                    fields: [
                        {
                            text: this.lng.translate(20018043, 'Soll der Termin für alle Teilnehmer gelöscht werden?'), name: 'allParticipants',
                            options: [{ text: this.lng.translate(20018046, "Nur für mich"), value: false }, { text: this.lng.translate(20018047, "Für alle Teilnehmer"), value: true }]
                        }
                    ]
                };
                this.promptOptionsApointmentDelete = {
                    title: this.lng.translate(20018033, "Termin"),
                    icon: "qm-icon-calendar_7",
                    yesNo: true,
                    id: "prompt-single-delete",
                    text: this.lng.translate(20018048, 'Wollen Sie den Termin wirklich löschen?')
                };
                this.promptOptionsSingleUpdate = {
                    title: this.lng.translate(20018033, "Termin"),
                    icon: "qm-icon-calendar_7",
                    yesNo: true,
                    id: "prompt-single-update",
                    text: this.lng.translate(20018049, 'Wollen Sie den Termin wirklich bearbeiten?')
                };
                this.promptOptionsSeriesUpdate = {
                    title: this.lng.translate(20018050, "Serientermin"),
                    icon: "qm-icon-calendar_7",
                    id: "prompt-change",
                    fields: [
                        {
                            text: this.lng.translate(20018051, 'Wollen Sie diesen Termin oder die ganze Serie bearbeiten?'), name: 'wholeSeries',
                            options: [{ text: this.lng.translate(20018044, "Dieser Termin"), value: false }, { text: this.lng.translate(20018045, "Alle Termine dieser Serie"), value: true }]
                        }
                    ]
                };
                this.promptOptionsOnlySeriesUpdate = {
                    title: this.lng.translate(20018050, "Serientermin"),
                    icon: "qm-icon-calendar_7",
                    yesNo: true,
                    id: "prompt-single-update",
                    text: this.lng.translate(20018054, 'Wollen Sie die Terminserie wirklich bearbeiten?')
                };
                $qui.init($qui.getSectionColor('/appointment'), function () {
                    _this.$timeout(function () { _this.render(); });
                    $qui.anonAvatar();
                    $qui.bindEvents();
                    $(".help-block").parent("div").attr("style", "");
                });
                this.$scope.$watch('vm.form.recuringType', function () {
                    var _a;
                    if (_this.form.recuringType > 0 && _this.form.recuringType !== null && _this.form.disableRecurring === false) {
                        _this.form.disableRecurringEndDate = false;
                        _this.form.rangeDateFrom = _this.form.dateFrom;
                        _this.form.rangeDateTo = (_a = _this.form.rangeDateTo) !== null && _a !== void 0 ? _a : _this.oldRangeDateTo;
                        _this.form.isRecurring = true;
                    }
                    else {
                        _this.form.disableRecurringEndDate = true;
                        _this.form.isRecurring = _this.form.recuringType !== null && _this.form.recuringType !== undefined;
                        _this.form.rangeDateTo = _this.form.isRecurring ? _this.form.rangeDateTo : null;
                    }
                });
                this.loading.participants = true;
                this.clientService.getPersonListByObjectTypes([120000, 130000, 140000, 140006], '', true, false).then(function (data) {
                    data.map(function (item) {
                        item.displayTitle = _this.$qui.createPersonDisplay(item.displayTitle, '', item.shortCaption, item.personNumber);
                        return item;
                    });
                    _this.clientService.getAllPersonLists().then(function (dataPL) {
                        _this.clientService.getResourceList('', true).then(function (dataRes) {
                            _this.clientService.getVehicleList().then(function (dataVeh) {
                                var temp = data.map(function (x) { return ({ text: x.displayTitle, value: x.objectId, group: _this.getGroupName(x.objectType), subText: x.institute }); });
                                temp = temp.concat(dataPL.map(function (x) { return ({ text: x.name, value: x.objectId, group: _this.lng.translate(20000237, 'Personenliste'), subText: '' }); }));
                                temp = temp.concat(dataRes.map(function (x) { return ({ text: x.caption, value: x.objectId, group: _this.lng.translate(20000271, 'Ressource'), subText: x.institute }); }));
                                temp = temp.concat(dataVeh.map(function (x) { return ({ text: x.displayTitle, value: x.objectId, group: _this.lng.translate(20029006, 'Fuhrpark'), subText: x.kindOfVehicle }); }));
                                temp.sort(function (a, b) { return (a.text.toLocaleLowerCase() > b.text.toLocaleLowerCase()) ? 1 : ((b.text.toLocaleLowerCase() > a.text.toLocaleLowerCase()) ? -1 : 0); });
                                temp.sort(function (a, b) { return (a.group.toLocaleLowerCase() > b.group.toLocaleLowerCase()) ? 1 : ((b.group.toLocaleLowerCase() > a.group.toLocaleLowerCase()) ? -1 : 0); });
                                _this.participants = temp;
                                _this.loading.participants = false;
                            });
                        });
                    });
                });
            }
            TerminDetailController.prototype.getParticipants = function () {
                return this.participants;
            };
            TerminDetailController.prototype.getGroupName = function (type) {
                switch (type) {
                    case 120000:
                        return this.lng.translate(20000235, 'Mitarbeiter');
                    case 130000:
                        return this.lng.translate(20000279, 'Organisation');
                    case 140000:
                        return this.lng.translate(21002000, 'Klient');
                    case 140006:
                        return this.lng.translate(20001048, 'Kontaktperson');
                    default:
                        return '';
                }
            };
            /**
             * convert a string to title case
             *
             * @private
             * @param {string} str
             * @returns {string}
             *
             * @memberOf TerminDetailController
             */
            TerminDetailController.prototype.toTitleCase = function (str) {
                return str.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
            };
            /**
             * init the form with default values
             *
             * @private
             *
             * @memberOf TerminDetailController
             */
            TerminDetailController.prototype.initForm = function () {
                this.form = {
                    title: null,
                    dateFrom: null,
                    dateTo: null,
                    isAllDay: true,
                    location: null,
                    participantIds: [],
                    description: null,
                    isFinished: false,
                    isPrivate: false,
                    rangeDateFrom: null,
                    rangeDateTo: null,
                    recuringType: 0,
                    disableRecurring: false,
                    disableRecurringEndDate: false,
                    recurrenceChangeDateFrom: null,
                    recurrenceChangeDateTo: null,
                    recurrenceData: null
                };
            };
            TerminDetailController.prototype.toogleBackButton = function () {
                var _this = this;
                this.$qui.waitForEl('#edit-form-detail', function () {
                    $('#edit-form-detail').on('hidden.bs.modal', function () {
                        for (var i = 0; i < _this.$state.history.length; i++) {
                            //in order to avoid getting the <</appointment/:id/:isRecurring/:participantId/:dateFrom/:start/:end>> also check if url is the basic home appointment url
                            if ((_this.$state.history[i].name === 'appointment') && (_this.$state.history[i].url === '/appointment?:startDay?view')) {
                                _this.$state.go(_this.$state.history[i].name, _this.$state.history[i].params);
                                var url = $("#session").data().baseUrl + _this.$state.history[i].url;
                                history.replaceState({ backButtonPresse: false }, '', url.replace('//', '/'));
                                break;
                            }
                        }
                    });
                });
            };
            /**
             * put an existing appointment
             *
             * @private
             * @param {any} form is modified IAppointmentUpdate, to inject participants
             *
             * @memberOf TerminListController
             */
            TerminDetailController.prototype.putAppointment = function (form) {
                var _this = this;
                this.validateAppointment(form);
                this.validationCallback = function () {
                    $('#edit-form-detail').modal('hide');
                    _this.sendPut(form);
                };
            };
            TerminDetailController.prototype.sendPut = function (form) {
                var _this = this;
                var _a;
                location.hash = "#/appointment";
                if (form.isRecurring) {
                    form.recurrenceOptions = this.reccuring.getOptions(Number(form.recuringType), form.dateFrom);
                    if (form.recuringType > 0) {
                        form.isRecurring = true;
                        if (form.recurrenceOptions === null)
                            form.isRecurring = false;
                        form.recurrenceOptions.rangeDateFrom = (_a = form.rangeDateFrom) !== null && _a !== void 0 ? _a : form.dateFrom;
                        form.recurrenceOptions.rangeDateTo = form.rangeDateTo;
                        this.reccuring.setRangeLimit(0);
                        if (form.recuringType > 0) {
                            this.reccuring.setRangeLimit(2);
                        }
                        //when the appointment is edited as a whole, do not forget to set the dateFrom and dateTo with the rageDateFrom
                        if (this.$stateParams.wholeSerie === "true") {
                            form.dateTo.setDate(form.dateFrom.getDate());
                            form.dateTo.setMonth(form.dateFrom.getMonth());
                            form.dateTo.setFullYear(form.dateFrom.getFullYear());
                            form.recurrenceOptions.rangeDateFrom = form.dateFrom;
                            form.rangeDateFrom = form.dateFrom;
                        }
                        form.recurrenceOptions = this.reccuring.getOptions(Number(form.recuringType), form.rangeDateFrom);
                    }
                }
                else {
                    form.recurrenceOptions = null;
                    form.recurrenceSettings = null;
                }
                this.terminService.putAppointment((form.isRecurring && form.recuringType > 0) ? form.mainAppointmentId : form.id, (form.isRecurring && form.recuringType > 0), this.selectedCalendar, form.isRecurring && form.recuringType > 0 ? form.rangeDateFrom : form.dateFrom, form.isRecurring && form.recurrenceOptions != null && !form.disableRecurring ? true : false, form).then(function () {
                    _this.ui.notify(_this.ui.successNote);
                    _this.formState = "new";
                    _this.resetData();
                });
            };
            /**
             * remove a appointment
             *
             * @private
             * @param {IAppointment} form
             *
             * @memberOf TerminListController
             */
            TerminDetailController.prototype.deleteAppointment = function (form) {
                var _this = this;
                $('#edit-form-detail').unbind('hidden.bs.modal');
                $('#edit-form-detail').modal('toggle');
                //if one participant, do not show the prompt for asking user to delete for him or for all participants
                this.promptOptions = form.participantIds.length > 1 ? this.promptOptionsAllParticipantsDelete : this.promptOptionsApointmentDelete;
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    if (data) {
                        _this.terminService.deleteAppointment(form.isRecurring ? form.mainAppointmentId : form.id, form.isRecurring, _this.selectedCalendar, form.isRecurring ? form.rangeDateFrom : form.dateFrom, _this.$stateParams.wholeSerie === "true" ? 1 : 0, form.participantIds.length > 1 ? data.allParticipants : false).then(function () {
                            _this.resetData();
                            _this.ui.notify(_this.ui.deleteNote, _this.lng.translate(20018032, "Termin gelöscht"));
                            _this.formState = 'new';
                            location.hash = "#/appointment";
                        });
                    }
                    else {
                        location.hash = '#/appointment';
                    }
                });
            };
            /**
             * reset the data of the full calendar
             *
             * @private
             *
             * @memberOf TerminDetailController
             */
            TerminDetailController.prototype.resetData = function () {
                $('#calendar').fullCalendar('removeEvents');
                this.calendarList = [];
                this.getPersonalCalendar();
            };
            /**
             * get the detail data by id
             *
             * @private
             *
             * @memberOf TerminDetailController
             */
            TerminDetailController.prototype.getDetailData = function () {
                var _this = this;
                this.permissions = {
                    new: true,
                    modify: false,
                    delete: false,
                };
                this.terminService.getAppointment(this.$stateParams.id, this.$stateParams.participantId, this.$stateParams.dateFrom, this.$stateParams.wholeSerie, this.$stateParams.permFlag).then(function (data) {
                    _this.permissions.delete = data.permissions.delete;
                    _this.permissions.new = data.permissions.new;
                    _this.permissions.modify = data.permissions.modify;
                    _this.selectedCalendar = _this.$stateParams.participantId;
                    _this.form = data;
                    _this.form.disableRecurring = _this.$stateParams.wholeSerie !== "true" && data.isRecurring;
                    _this.formState = 'edit';
                    if (_this.form.recurrenceOptions !== null) {
                        _this.form.recuringType = _this.reccuring.setInputField(_this.form.recurrenceOptions);
                        _this.oldRecurringType = _this.form.recuringType;
                    }
                    _this.form.dateFrom = _this.$qui.createDateFromString(!data.isRecurring || _this.$stateParams.start == 0 || _this.$stateParams.wholeSerie === "true" ? data.dateFrom : _this.$stateParams.start);
                    _this.form.dateTo = _this.$qui.createDateFromString(!data.isRecurring || _this.$stateParams.end == 0 || _this.$stateParams.wholeSerie === "true" ? data.dateTo : _this.$stateParams.end);
                    if (data.isRecurring) {
                        _this.form.rangeDateTo = data.recurrenceOptions.rangeDateTo != null ?
                            _this.$qui.createDateFromString(data.recurrenceOptions.rangeDateTo) : null;
                        _this.form.rangeDateFrom = data.recurrenceOptions.rangeDateFrom != null ?
                            _this.$qui.createDateFromString(data.recurrenceOptions.rangeDateFrom) :
                            _this.$qui.createDateFromString(_this.form.dateFrom);
                        _this.form.rangeDateFrom.setTime(_this.form.dateFrom.getTime());
                        _this.oldRangeDateTo = _this.form.rangeDateTo;
                    }
                    else {
                        _this.form.disableRecurringEndDate = false;
                        _this.form.rangeDateFrom = _this.$qui.createDateFromString(_this.form.dateFrom);
                        _this.form.rangeDateTo = _this.form.dateTo;
                        _this.form.isRecurring = false;
                    }
                    _this.form.recurrenceChangeDateFrom = data.isRecurring ? _this.form.rangeDateFrom : _this.form.dateFrom;
                    _this.form.recurrenceChangeDateTo = data.isRecurring ? _this.form.rangeDateTo : _this.form.dateTo;
                    _this.form.recurringType = _this.reccuring.setInputField(data.recurrenceOptions);
                    $('#edit-form-detail').modal('show');
                    _this.loading.appointment = false;
                    _this.waitToCreateForm();
                    _this.toogleBackButton();
                });
            };
            TerminDetailController.prototype.waitToCreateForm = function () {
                var _this = this;
                if (!this.loading.appointment && !this.loading.participants) {
                    this.$timeout(function () {
                        _this.$qui.functionWaiter("ui.createDetailForm", _this);
                        _this.$qui.scopeApply(_this.$scope);
                    });
                }
                else {
                    setTimeout(function () {
                        _this.waitToCreateForm();
                    }, 250);
                }
            };
            /**
             * get the personal calendar
             *
             * @private
             *
             * @memberOf TerminDetailController
             */
            TerminDetailController.prototype.getPersonalCaalendar = function () {
                var _this = this;
                this.terminService.getCalendarList().then(function (data) {
                    var d = new Date();
                    var n = d.getFullYear();
                    _this.getDateList(data[0].personObjectId, n + '-01-01' /* moment().startOf('isoWeek').format("YYYY-MM-DD")*/, (n + 1) + '-12-31' /*moment().endOf('isoWeek').format("YYYY-MM-DD")*/);
                    _this.personalCalendar = data;
                    _this.$timeout(function () {
                        $('#calendar').fullCalendar('addEventSource', _this.calendarList);
                    });
                });
            };
            TerminDetailController.prototype.getPersonalCalendar = function () {
                this.setViewDates();
                $('#calendar').fullCalendar('removeEvents');
                this.requestLock = true;
                this.getDateList(this.selectedCalendar, this.viewDateFrom, this.viewDateTo);
                this.loading.calendar = false;
            };
            /**
             * get the date list by id, date from, and date to from the api
             *
             * @private
             * @param {Guid} id
             * @param {Date} dateFrom
             * @param {Date} dateTo
             *
             * @memberOf TerminListController
             */
            TerminDetailController.prototype.getDateList = function (id, dateFrom, dateTo) {
                var _this = this;
                if (this.loadingSemaphor)
                    return;
                this.loadingSemaphor = true;
                $('#calendar').fullCalendar('removeEvents');
                $('#calendar').fullCalendar('removeEventSources');
                this.calendarList = [];
                this.loading.calendar = true;
                this.$timeout(function () {
                    _this.terminService.getAppointmentList(_this.selectedCalendar, dateFrom, dateTo, _this.appointmentTypesToShow).then(function (data) {
                        if (data[0] !== undefined)
                            if (data[0].objectId.toString().length > 1) {
                                for (var i = 0; i < data.length; i++) {
                                    _this.calendarList.push(_this.ui.createCalendarEvent(data[i], _this.$qui.generateGuid()));
                                }
                            }
                        $('#calendar').fullCalendar('addEventSource', _this.calendarList);
                        _this.loading.calendar = false;
                        _this.setupCalendar();
                        _this.loadingSemaphor = false;
                    });
                });
            };
            /**
             * set the view dates for the fullcalendar
             *
             * @private
             *
             * @memberOf TerminListController
             */
            TerminDetailController.prototype.setViewDates = function () {
                var dateFrom = $('#calendar').fullCalendar('getView').start;
                var dateTo = $('#calendar').fullCalendar('getView').end;
                if (typeof dateFrom !== "object")
                    dateFrom = new Date();
                if (typeof dateTo !== "object")
                    dateTo = new Date();
                this.viewDateFrom = moment(dateFrom).startOf('week').format();
                this.viewDateTo = moment(dateTo).endOf('week').add(1, 'day').format();
            };
            /**
             * render the fullcalendar
             *
             * @private
             *
             * @memberOf TerminDetailController
             */
            TerminDetailController.prototype.render = function () {
                this.ui.createDetailForm();
                this.$timeout(function () {
                    $('#calendar').fullCalendar('render');
                });
            };
            /**
             * when a event on the fullcalendar has changed
             *
             * @private
             * @param {any} id
             * @param {any} data
             *
             * @memberOf TerminListController
             */
            TerminDetailController.prototype.changeEvents = function (id, isRecurring, participantId, dateFrom, data) {
                var _this = this;
                if (id !== undefined) {
                    if (data.dateTo === null)
                        data.dateTo = data.dateFrom;
                    data.dateFrom = moment(data.dateFrom).toDate();
                    data.dateTo = moment(data.dateTo).toDate();
                    data.mainAppointmentId = id;
                    data.participantIds = [participantId];
                    data.changeDatesOnly = true;
                    this.validateAppointment(data);
                    this.validationCallback = function () {
                        _this.terminService.putAppointment(id, isRecurring, participantId, dateFrom, false, data).then(function () {
                            _this.$qui.notify(_this.$qui.successNote);
                            _this.resetData();
                        });
                    };
                }
            };
            /**
             * Returns a qmc calendar event which can be shown in the calendar
             * @param appointment The appointment object
             */
            TerminDetailController.prototype.createCalendarEvent = function (appointment) {
                var event = {};
                event.id = appointment.objectId;
                event.objectId = appointment.objectId;
                event.mid = appointment.mainAppointmentId;
                event.title = appointment.title;
                event.start = moment(appointment.dateFrom);
                event.end = moment(appointment.dateTo);
                event.allDay = appointment.isAllDay;
                event.isFinished = appointment.isFinished;
                event.isPrivate = appointment.isPrivate;
                event.isRecurring = appointment.isRecurring;
                event.isTypeAppointment = appointment.isTypeAppointment;
                event.editable = true;
                event.color = appointment.colorHtml;
                event.iconCode = "";
                if (event.isFinished) {
                    event.iconCode += "<i class='fa fa-check'></i> ";
                }
                if (event.isPrivate) {
                    event.iconCode += "<i class='fa fa-lock'></i> ";
                }
                if (event.isRecurring) {
                    event.iconCode += "<i class='fa fa-refresh'></i> ";
                    event.editable = false;
                }
                if (event.isDeleted) {
                    event.iconCode += "<i class='fa fa-trash'></i> ";
                }
                if (!event.isTypeAppointment) {
                    event.editable = false;
                }
                return event;
            };
            /**
             * setup the full calendar
             *
             * @private
             *
             * @memberOf TerminDetailController
             */
            TerminDetailController.prototype.setupCalendar = function () {
                var _this = this;
                this.$timeout(function () {
                    $('.fc-event').each(function () {
                        $(this).data('event', {
                            title: $.trim($(this).text()),
                            stick: true
                        });
                        $(this).draggable({
                            zIndex: 999,
                            revert: true,
                            revertDuration: 0
                        });
                    });
                });
                var allDayText = this.lng.translate(20018016, "Ganztägig");
                $('#calendar').fullCalendar({
                    schedulerLicenseKey: QMC.Common.Constants.FULL_CALENDAR_PREMIUM_LICENSE,
                    contentHeight: $(window).height() * 0.6,
                    defaultView: this.ui.deviceDefault(),
                    allDayText: allDayText,
                    timezone: "local",
                    allDaySlot: true,
                    slotLabelFormat: 'H:mm',
                    events: this.calendarList,
                    firstDay: 1,
                    monthNames: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'July', 'August', 'September', 'Oktober', 'November', 'Dezember'],
                    monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
                    dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
                    dayNamesShort: ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'],
                    weekNumbers: true,
                    weekNumberCalculation: function (date) { return moment(date).isoWeek(); },
                    nowIndicator: true,
                    views: {
                        month: {
                        //titleFormat: 'MMMM yyyy'
                        },
                        week: {
                            titleFormat: 'dddd, D MMM YYYY'
                        },
                        day: {
                            titleFormat: 'dddd D.MM'
                        }
                    },
                    buttonText: {
                        today: 'Heute',
                        month: 'Monat',
                        week: 'Woche',
                        day: 'Tag'
                    },
                    viewRender: function () { _this.getPersonalCalendar(); },
                    columnFormat: 'ddd D.M',
                    timeFormat: 'H:mm',
                    header: {
                        left: 'prev,next today',
                        center: 'title',
                        right: 'month, agendaWeek, agendaDay'
                    },
                    editable: true,
                    droppable: true,
                    eventRender: function (event, element) {
                        $(element).find(".fc-title").prepend(event.iconCode);
                    },
                    eventResize: function (event) {
                        var newForm = {
                            dateFrom: event.start,
                            dateTo: event.end,
                            title: event.title,
                            isAllDay: event.allDay,
                            changeDatesOnly: true
                        };
                        _this.changeEvents(event.isRecurring ? event.mid : event.objectId, event.isRecurring, event.participantObjectId, event.start, newForm);
                    },
                    eventDrop: function (event) {
                        var newForm = {
                            dateFrom: event.start,
                            dateTo: event.end,
                            title: event.title,
                            isAllDay: event.allDay,
                            changeDatesOnly: true
                        };
                        _this.calendarList = [];
                        _this.changeEvents(event.isRecurring ? event.mid : event.objectId, event.isRecurring, event.participantObjectId, event.start, newForm);
                    },
                    drop: function () {
                    },
                    aspectRatio: 5,
                    eventClick: function (event) {
                        // alert("Id: " + event.id + ". MainAppointmentId: " + event.mid + ". DateFrom: " + event.start.toISOString());
                        if (event.editable) {
                            var path = _this.ui.detailLink(event);
                            if (location.hash !== path)
                                location.hash = path;
                            else
                                _this.getDetailData();
                        }
                    },
                    dayClick: function (date, jsEvent, view) {
                        if (view.name === 'month') {
                            $('#calendar').fullCalendar('gotoDate', date);
                            $('#calendar').fullCalendar('changeView', 'agendaWeek');
                        }
                    }
                });
            };
            TerminDetailController = __decorate([
                QMC.Controller('QMC.Termin', 'TerminDetailController'),
                QMC.Inject('TerminService', '$qui', 'FachleistungService', '$state', '$stateParams', '$scope', '$timeout', 'KlientService', 'QmcLanguageService', 'QmcPermissionService')
            ], TerminDetailController);
            return TerminDetailController;
        }());
    })(Termin = QMC.Termin || (QMC.Termin = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Termin;
    (function (Termin) {
        var RecurringOptions = /** @class */ (function () {
            function RecurringOptions() {
                this.reccuringSelectList = [];
                this.reccuringTypes = ['Niemals', 'Täglich', 'Wöchentlich', 'Alle 2 Wochen', 'Monatlich', 'Jährlich'];
                this.getInfragisticsWeekday = function (date) {
                    switch (date.getDay()) {
                        case 0:
                            return 1;
                        case 1:
                            return 2;
                        case 2:
                            return 4;
                        case 3:
                            return 8;
                        case 4:
                            return 16;
                        case 5:
                            return 32;
                        case 6:
                            return 64;
                        default:
                            return 1;
                    }
                };
                this.options = {
                    "frequency": 1,
                    "rangeLimit": 0,
                    "rangeMaxOcurrences": 0,
                    "rangeDateFrom": "2017-05-02T08:33:03.820Z",
                    "rangeDateTo": "2030-05-02T08:33:03.820Z",
                    "occurence": 0,
                    "interval": 1,
                    "dayOfMonth": 0,
                    "monthOfYear": 0,
                    "daysOfWeek": [0]
                };
                this.options.rangeDateFrom = new Date();
                this.setOptionList();
            }
            RecurringOptions.prototype.setOptionList = function () {
                var _this = this;
                var optionWrap = function (val) {
                    _this.reccuringSelectList.push({
                        value: _this.reccuringSelectList.length,
                        text: val,
                        isFix: _this.reccuringSelectList.length < 1
                    });
                };
                for (var recType in this.reccuringTypes)
                    optionWrap(this.reccuringTypes[recType]);
                setTimeout(function () { $("#recuringType").val(0); }, 950);
            };
            RecurringOptions.prototype.setInputField = function (options) {
                console.log("options", options);
                if (options == null)
                    return 0;
                if (options.frequency === 0)
                    return 1;
                if (options.frequency === 1) {
                    if (options.interval === 1)
                        return 2;
                    if (options.interval === 2)
                        return 3;
                }
                if (options.frequency === 2)
                    return 4;
                if (options.frequency === 3)
                    return 5;
                return 0;
            };
            RecurringOptions.prototype.getOptions = function (type, date) {
                if (type < 0)
                    return null;
                switch (type) {
                    case 0:
                        return null;
                    case 1:
                        this.options.frequency = 0;
                        this.options.interval = 1;
                        this.options.daysOfWeek = [127];
                        break;
                    case 2:
                        this.options.frequency = 1;
                        this.options.interval = 1;
                        this.options.daysOfWeek = [];
                        this.options.daysOfWeek.push(this.getInfragisticsWeekday(date));
                        break;
                    case 3:
                        this.options.frequency = 1;
                        this.options.interval = 2;
                        this.options.daysOfWeek = [];
                        this.options.daysOfWeek.push(this.getInfragisticsWeekday(date));
                        break;
                    case 4:
                        this.options.frequency = 2;
                        this.options.interval = 1;
                        this.options.dayOfMonth = date.getDate();
                        break;
                    case 5:
                        this.options.frequency = 3;
                        this.options.interval = 1;
                        this.options.dayOfMonth = date.getDate();
                        this.options.monthOfYear = date.getMonth() + 1;
                        break;
                }
                return this.options;
            };
            RecurringOptions.prototype.setRangeLimit = function (limit) {
                this.options.rangeLimit = limit;
            };
            return RecurringOptions;
        }());
        Termin.RecurringOptions = RecurringOptions;
    })(Termin = QMC.Termin || (QMC.Termin = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Termin;
    (function (Termin) {
        var TerminDirective = /** @class */ (function () {
            function TerminDirective() {
                this.restrict = 'E';
                this.templateUrl = './Termin/Widget';
                this.replace = true;
                this.scope = {};
                this.controllerAs = 'vm';
                this.controller = 'TerminListController';
                this.bindToController = true;
                this.link = function (scope, element, attrs, ctrl) {
                    ctrl.isWidget = true;
                    ctrl.calendarName = 'widgetCalendar';
                    scope.dateNow = Date.now();
                    scope.forbidden = false;
                    scope.openNewModal = function () {
                        ctrl.initForm();
                        $('#edit-form').modal('toggle');
                    };
                    ctrl.setupCalendar = function () {
                        var _this = this;
                        var _a;
                        var allDayText = this.lng.translate(20018016, "Ganztägig");
                        //var newDateText = this.lng.translate(20018040, "Neuer Termin");
                        $("#" + ctrl.calendarName).fullCalendar({
                            schedulerLicenseKey: QMC.Common.Constants.FULL_CALENDAR_PREMIUM_LICENSE,
                            defaultView: 'listWeek',
                            allDayText: allDayText,
                            monthNames: this.lng.translate(20018519, 'Januar,Februar,März,April,Mai,Juni,Juli,August,September,Oktober,November,Dezember').split(','),
                            monthNamesShort: this.lng.translate(20018520, 'Jan,Feb,Mrz,Apr,Mai,Jun,Jul,Aug,Sep,Okt,Nov,Dez').split(','),
                            dayNames: this.lng.translate(20018521, 'Sonntag,Montag,Dienstag,Mittwoch,Donnerstag,Freitag,Samstag').split(','),
                            dayNamesShort: this.lng.translate(20018522, 'So.,Mo.,Di.,Mi.,Do.,Fr.,Sa.').split(','),
                            timezone: "local",
                            nowIndicator: true,
                            events: (_a = scope.qmData) !== null && _a !== void 0 ? _a : [],
                            height: 'auto',
                            firstDay: 1,
                            scrollTime: moment(new Date()).format("HH:mm:ss"),
                            titleFormat: '[Termine]',
                            eventDurationEditable: false,
                            eventStartEditable: false,
                            noEventsMessage: this.lng.translate(20018529, 'keine kommenden Termine in dieser Woche'),
                            views: {
                                day: {
                                    titleFormat: 'dddd D.MM'
                                }
                            },
                            header: {
                                left: '',
                                center: '',
                                right: ''
                            },
                            //customButtons: {
                            //    addBtn: {
                            //        text: newDateText,
                            //        click: function () {
                            //            $('#edit-form-detail').modal('toggle');
                            //        }
                            //    }
                            //},
                            eventRender: function (event, element) {
                                element.find(".fc-list-item-title").prepend(event.iconCode);
                            },
                            eventAfterAllRender: function () {
                                _this.ui.formatListDates();
                            },
                            eventClick: function (event) {
                                if (event.end === undefined || event.end === null)
                                    event.end = event.start;
                                $("#" + ctrl.calendarName).fullCalendar('removeEvents');
                                location.hash = location.hash = _this.ui.detailLink(event, event.isRecurring);
                            },
                        });
                    };
                    ctrl.widgetRender = function (calEvents) {
                        scope.qmData = calEvents;
                        if (calEvents && calEvents.length >= 1) {
                            ctrl.setupCalendar();
                            setTimeout(function () {
                                $("#" + ctrl.calendarName).fullCalendar('render');
                            }, 500);
                        }
                    };
                };
            }
            TerminDirective = __decorate([
                QMC.Directive('QMC.Termin', 'qmAppointmentWidget', [])
            ], TerminDirective);
            return TerminDirective;
        }());
    })(Termin = QMC.Termin || (QMC.Termin = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Termin;
    (function (Termin) {
        var TerminValidationDirective = /** @class */ (function () {
            function TerminValidationDirective(appointmentService, lng) {
                var _this = this;
                this.appointmentService = appointmentService;
                this.lng = lng;
                this.restrict = 'EA';
                this.templateUrl = './Termin/Validation';
                this.replace = true;
                this.scope = {
                    callback: '&',
                    validate: '='
                };
                this.link = function (scope) {
                    var formStore;
                    scope.id = 'appointmentValidationModal_' + Math.random().toString(36).substr(2, 9);
                    scope.validationResult = {
                        '': {
                            warnings: [],
                            errors: [_this.lng.translate(20000328, 'Es konnte keine Validierung durchgeführt werden')]
                        }
                    };
                    scope.validate = function (form) {
                        formStore = form;
                        $("#appointmentValidationModal_" + scope.id).modal('show');
                        scope.loading = true;
                        _this.appointmentService.validateAppointment({
                            dateFrom: form.dateFrom,
                            dateTo: form.dateTo,
                            attendeeIds: form.participantIds,
                            mainAppointmentId: form.mainAppointmentId
                        }).then(function (data) {
                            scope.validationResult = data;
                            if (scope.noErrors() && scope.noWarnings())
                                scope.save();
                        }).catch(function () {
                            scope.validationResult = {
                                '': {
                                    warnings: [],
                                    errors: [_this.lng.translate(20000328, 'Es konnte keine Validierung durchgeführt werden')]
                                }
                            };
                        }).finally(function () { return scope.loading = false; });
                    };
                    scope.noErrors = function () {
                        if (!scope.validationResult)
                            return false;
                        for (var attendee in scope.validationResult) {
                            if (scope.validationResult[attendee].errors.length)
                                return false;
                        }
                        return true;
                    };
                    scope.noWarnings = function () {
                        if (!scope.validationResult)
                            return false;
                        for (var attendee in scope.validationResult) {
                            if (scope.validationResult[attendee].warnings.length)
                                return false;
                        }
                        return true;
                    };
                    scope.save = function () {
                        $("#appointmentValidationModal_" + scope.id).modal('hide');
                        scope.callback()(formStore);
                    };
                };
            }
            TerminValidationDirective = __decorate([
                QMC.Directive('QMC.Termin', 'qmAppointmentValidation', ['TerminService', 'QmcLanguageService'])
            ], TerminValidationDirective);
            return TerminValidationDirective;
        }());
    })(Termin = QMC.Termin || (QMC.Termin = {}));
})(QMC || (QMC = {}));

//# sourceMappingURL=../../maps/Termin/qmc.termin.js.map
